export class BookingProcessProgressBar {
  public readonly totalSteps: number;
  public readonly currentStep: number;
}
